import React from "react";
import { useField, useFormikContext } from 'formik';
import {FieldError} from "../Error/FieldError.jsx";
import {DatePicker, ToggleButton} from "@progress/kendo-react-dateinputs";
import {calendarIcon, xIcon} from '@progress/kendo-svg-icons';

export const DatePickerInput = ({ label, required, style, disabled = false, onChange, ...otherProps }) => {
    const [field, meta] = useField(otherProps);
    const formikContext = useFormikContext();
    const { setFieldValue, values } = formikContext;

    // If disabled is a function, call it with the full form context
    const isDisabled = typeof disabled === 'function'
        ? disabled({
            ...formikContext,
            fieldName: otherProps.name,
            currentValue: values[otherProps.name]
        })
        : disabled;

    const handleChange = async (e) => {
        const newValue = e.target.value;

        if (onChange) {
            // Let the custom onChange handle field updates
            await onChange(e, {
                ...formikContext,
                fieldName: otherProps.name,
                newValue,
                previousValue: values[otherProps.name]
            });
        } else {
            // Default behavior: update Formik's state
            await setFieldValue(otherProps.name, newValue);
        }
    };

    const clearDate = () => {
        setFieldValue(otherProps.name, null);
    };

    const CustomToggleButton = (props) => {
        return (
            <>
                <ToggleButton {...props} svgIcon={calendarIcon} />
                    <ToggleButton
                        {...props}
                        svgIcon={xIcon}
                        disabled={!(field?.value || isDisabled)}
                        onClick={clearDate}
                        aria-label="Clear the DatePicker"
                    />
            </>
        );
    };

    return (
        <>
            {label && (
                <label htmlFor={otherProps.id || otherProps.name}>
                    {label}
                    {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
                </label>
            )}
            <DatePicker
                id={otherProps.id || otherProps.name}
                {...field}
                {...otherProps}
                toggleButton={CustomToggleButton}
                disabled={isDisabled}
                onChange={handleChange}
            />
            <FieldError name={otherProps.name}/>
        </>
    );
};